<template>
  <v-container style="margin-top: 100px;" class="align-center justify-center text-center">
    <v-row v-if="$store.state.isLoggedIn">
        <v-col>
          <v-btn to="/dashboard" class="primary">
            <v-icon left>mdi-view-dashboard</v-icon>{{$t('home.goto-dashboard')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-btn to="/login" class="primary">
            <v-icon left>mdi-login</v-icon>{{$t('common.login')}}
          </v-btn>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>

import { MUTATION_RAISE_NOTIFICATION, MUTATION_DISMISS_NOTIFICATION } from "@/plugins/store.js";

export default {
  name: "ErrorView",
  components: {
  },
  props: {
    message: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
    };
  },
  mounted: function() {
    if (this.message) {
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        type: "error",
        message: this.message
      });
    }
  },
  destroyed: function () {
    this.$store.commit(MUTATION_DISMISS_NOTIFICATION);
  },
  methods: {}
};
</script>
